import React from 'react';
import { Col, Row } from 'antd';

import { CardAttachments } from '../../../components/CardAttachments';
import { DadosVeiculos } from '../DadosVeiculos';

export function TabVeiculos({
  imgsVeiculo,
  solicitacao,
  spinningImg = false,
  openTabe = () => {},
  indexImgVeiculo = () => {},
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  return (
    <Row
      justify="space-between"
      style={{
        padding: '16px 0',
      }}
    >
      <Col justify="center" md={24} lg={24} xs={24}>
        <CardAttachments
          imagens={imgsVeiculo || []}
          handlerOpenImg={indexImgVeiculo}
          updateList={openTabe}
          spinning={spinningImg}
        />
      </Col>
      <Col justify="center" md={24} lg={24} xs={24}>
        <DadosVeiculos
          dadosDaConsulta={solicitacao}
          carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          setSpinning={setSpinning}
          tipoValidacao={tipoValidacao}
        />
      </Col>
    </Row>
  );
}
